module.exports = __webpack_public_path__ + "img/SketchPngd482428c11ede40e3ef3413a471537cfbc3cfd1dc9361beefa4554aacf5cb293.201d7a59.png";